import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "container page-frame" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "row justify-content-md-center" }
const _hoisted_4 = { class: "table col-12 col-md-8" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["disabled", "onClick"]
const _hoisted_7 = { class: "row justify-content-between table-title-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.authStore.getters.authLevel !== _ctx.authLevels.DIST_STAFF)
      ? (_openBlock(), _createBlock(_component_Breadcrumbs, {
          key: 0,
          here: '請求書再送',
          ancestries: _ctx.ancestries
        }, null, 8, ["ancestries"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "col h2",
        style: _normalizeStyle({ fontSize: _ctx.FontSizes.large2})
      }, _toDisplayString(_ctx.staff.userName) + "さんの請求書再送", 5)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("table", _hoisted_4, [
        _cache[2] || (_cache[2] = _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", null, "年月"),
            _createElementVNode("th", null, "請求額"),
            _createElementVNode("th", null, "振込手数料"),
            _createElementVNode("th")
          ])
        ], -1)),
        _createElementVNode("tbody", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.invoiceStatuses, (status, i) => {
            return (_openBlock(), _createElementBlock("tr", { key: i }, [
              _createElementVNode("td", null, _toDisplayString(_ctx.toYearMonthStr(status.yearMonth)), 1),
              _createElementVNode("td", null, "¥" + _toDisplayString(Math.floor(status.invoice.amount).toLocaleString()), 1),
              _createElementVNode("td", null, [
                (status.invoice.amount > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, "¥"))
                  : _createCommentVNode("", true),
                _createTextVNode(_toDisplayString(_ctx.transferFeeStr(status)), 1)
              ]),
              _createElementVNode("td", null, [
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  disabled: status.invoice.amount === 0,
                  onClick: ($event: any) => (_ctx.onClickResendInvoice(status))
                }, "再送", 8, _hoisted_6)
              ])
            ]))
          }), 128))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_ctx.page > 1)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevPage && _ctx.prevPage(...args))),
            class: "btn btn-info col-12 col-md-4 align-self-center mar-8"
          }, " 前のページ "))
        : _createCommentVNode("", true),
      _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1)),
      (_ctx.page < _ctx.maxPage)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextPage && _ctx.nextPage(...args))),
            class: "btn btn-info col-12 col-md-4 align-self-center mar-8"
          }, " 次のページ "))
        : _createCommentVNode("", true)
    ])
  ]))
}